import React, { useState, useEffect } from 'react';
import ChartImpliedWacc from './ChartImpliedWacc';
import { fetchData } from './FetchData';

function filterData(data) {
  return data.filter((d) => {
    return true;
  });
}

function prepareChartImpliedWaccData(data) {
  // usually more wrangling is required but the example data is simple
  return data;
}

const useData = (dataSet) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchNewData = async () => {
      try {
        setLoading(true);
        setError(false);
        const data = await fetchData(dataSet);
        const dataClean = filterData(data);
        setData(prepareChartImpliedWaccData(dataClean));
        setLoading(false);
      } catch (err) {
        console.log(err);
        setError(err);
        setLoading(false);
      }
    };
    fetchNewData();
  }, [dataSet]);

  return [data, loading, error];
};

const ChartImpliedWaccData = () => {
  const [dataSet, setDataSet] = useState('dataImpliedWacc');
  const [data, loading, error] = useData(dataSet);

  return (
    <>
      <ChartImpliedWacc data={data} error={error} loading={loading} />
    </>
  );
};

export default ChartImpliedWaccData;
